import { BasePage } from '@/components/ui/base-page'

export function CreditPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add CreditPage specific content here */}
    </BasePage>
  )
}